import { useDebouncedSearch } from '@consigli/hooks';
import { type Finding } from '@consigli/types';
import { useState, type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { AddContextFindingCard } from './add-context-finding-card';
import { AddContextPanel, SEARCH_DEBOUNCE_MS } from './add-context-panel';
import { useAddContextFindings } from './use-add-context-findings';

interface AddContextFindingsPanelProps {
  onSelectedChange: (findings: Finding[]) => void;
  selected: Finding[];
}

/** The findings this package holds: what to fetch, and how a finding is drawn. */
export const AddContextFindingsPanel: FC<AddContextFindingsPanelProps> = ({
  onSelectedChange,
  selected,
}) => {
  const { t } = useTranslation();
  const [searchText, setSearchText] = useState('');
  const debouncedSearchText = useDebouncedSearch(searchText.trim(), SEARCH_DEBOUNCE_MS);
  const list = useAddContextFindings(true, debouncedSearchText);

  return (
    <AddContextPanel
      emptyMessage={t('prop-chat.add-context-no-findings')}
      list={list}
      onSearchTextChange={setSearchText}
      onSelectedChange={onSelectedChange}
      renderItem={(finding, isSelected, onToggle) => (
        <AddContextFindingCard
          key={finding.id}
          finding={finding}
          onSelectedChange={onToggle}
          selected={isSelected}
        />
      )}
      searchLabel={t('findings.search-findings')}
      searchText={searchText}
      selected={selected}
    />
  );
};
